<template>
  <Dialog v-model="showDialog" :showClose="true">
    <div class="choose-list">
      <div class="message-user">
        <div class="nik-icon"><img :src="userInfo.userAvatarImg" alt="" /></div>
        <div class="nik-name">{{ userInfo.userName }}</div>
      </div>
      <div class="left-message">请选择留言</div>
      <ul class="activity-list-wrapper">
        <li class="messageName" v-for="(item, index) in templateList" :key="`city_${index}`" @click="handleChoose(item, index)">
          <div class="left">
            <div :class="curIndex === index ? 'active' : ''" :style="{ borderColor: curIndex === index ? fontColor : '#dddddd', background: curIndex === index ? fontColor : '#ffffff' }">
              <img v-if="curIndex === index" src="../../assets/images/icon_selected.png" alt="" />
            </div>
          </div>
          <div class="right">{{ item.copywriting }}</div>
        </li>
      </ul>
      <div class="footer-message" @click="handleSharePoster">
        <div :style="{ background: btnColorMsg }">发布</div>
      </div>
      <Toast />
    </div>
  </Dialog>
</template>
<script>
import Dialog from "../Dialog"
import Toast from "../Toast"
import { mapMutations, mapGetters, mapActions } from "vuex"
import { sentMessage, buryingPoint } from "@/server/interfaces"
export default {
  name: "uiChooseCityDialog",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      curIndex: "",
      chooseMessage: {}
    }
  },
  methods: {
    ...mapMutations({
      showToast: "toast/showToast",
      updateMyMessageList: "activityInfo/updateMyMessageList",
      setUserInfo: "userInfo/setUserInfo"
    }),
    ...mapActions({
      updateNewMesageList: "activityInfo/updateNewMesageList",
      getMyMessageList: "activityInfo/getMyMessageList"
    }),
    handleChoose(messageItem, index) {
      this.curIndex = index
      Object.assign(this.chooseMessage, messageItem)
      // this.setTempCard([{ message: this.chooseMessage.copywriting, likeCount: this.maxCount }])
    },
    async handleSharePoster() {
      if (this.chooseMessage.id) {
        let params = {
          refColumn: this.activityDetail.columnId,
          refTemplate: this.chooseMessage.id,
          userName: this.userInfo.userName,
          likeCount: this.maxCount + 1
        }
        let res = await sentMessage({ params })
        if (res) {
          if (String(res) !== "true") {
            this.setUserInfo({ userName: res })
          }
          this.curIndex = ""
          let myMessageList = { message: this.chooseMessage.copywriting, likeCount: params.likeCount }
          this.updateMyMessageList(myMessageList)
          this.updateNewMesageList([Object.assign(myMessageList, { userName: this.userInfo.userName })])
          this.$emit("showposter", true)
          this.chooseMessage = {}
          this.showDialog = false
          this._buryingPointSendMsgSucc()
        }
      } else {
        this.showToast("请选择留言")
      }
    },
    _buryingPointSendMsgSucc() {
      const params = {
        action: 11
      }
      buryingPoint({ params })
    }
  },
  components: {
    Dialog,
    Toast
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit("input", val)
      }
    },
    ...mapGetters({
      templateList: "activityInfo/templateList",
      userInfo: "userInfo/userInfo",
      activityDetail: "activityInfo/activityDetail",
      maxCount: "activityInfo/maxCount",
      myMessageList: "activityInfo/myMessageList",
      fontColor: "activityInfo/fontColor",
      btnColorMsg: "activityInfo/btnColorMsg"
    })
  }
}
</script>

<style lang="scss" scoped>
.choose-list {
  width: 750px;
  max-height: 592px;
}
.message-user {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  top: -32px;
  .nik-icon {
    width: 1.3rem;
    height: 1.3rem;
    border-radius: 50%;
    overflow: hidden;
    margin-bottom: 0.1rem;
    img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
  }
}
.left-message {
  width: 100%;
  padding: 0 40px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #999999;
  letter-spacing: 0;
  text-align: justify;
  line-height: 24px;
  margin-top: 96px;
}
.activity-list-wrapper {
  //margin-top: 0.9rem;
  width: 100%;
  max-height: 326px;
  padding: 0 40px;
  padding-top: 18px;
  display: flex;
  flex-direction: column;
  overflow: auto;
  .messageName {
    width: 100%;
    font-size: 32px;
    white-space: wrap !important;
    word-break: break-all;
    word-wrap: break-word;
    //margin-bottom: 0.3rem;
    border-bottom: 1px solid #dddd;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex: none;
    cursor: pointer;
    .right {
      padding: 30px 0;
      font-family: PingFangSC-Regular;
      font-size: 18px;
      display: flex;
      align-items: center;
      white-space: wrap !important;
      word-break: break-all;
      word-wrap: break-word;
    }
    .left {
      width: 28px;
      display: flex;
      justify-content: center;
      align-items: center;
      div {
        width: 28px;
        height: 28px;
        border: 3px solid #dddddd;
        border-radius: 50%;
        background: #fff;
      }
      margin-right: 20px;
      .active {
        width: 28px;
        height: 28px;
        border-width: 3px;
        border-style: solid;
        border-radius: 50%;
        background: #005f6c;
        display: flex;
        justify-content: center;
        align-items: center;
        img {
          width: 28px;
          height: 28px;
          object-fit: scale-down;
          transform: scale(0.8);
        }
      }
    }
    &:active {
      opacity: 0.7;
    }
  }
}
.footer-message {
  width: 100%;
  height: 116px;
  position: relative;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  div {
    width: 300px;
    height: 56px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-image: linear-gradient(-179deg, #2fd08a 0%, #2aa29d 98%);
    border-radius: 50px;
    font-family: PingFangSC-Medium;
    font-size: 20px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    cursor: pointer;
  }
}
</style>
